// import React, { useState } from "react";
// import { collection, getDocs, updateDoc, doc, Timestamp } from "firebase/firestore";
// import * as XLSX from "xlsx";
// import db from "./Firebase";

// const ExtendMembership = () => {
//     const [phoneNumbers, setPhoneNumbers] = useState([]);

//     const handleFileUpload = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const reader = new FileReader();
//         reader.onload = (event) => {
//             const binaryStr = event.target.result;
//             const workbook = XLSX.read(binaryStr, { type: "binary" });
//             const sheetName = workbook.SheetNames[0];
//             const data = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

//             // Extract phone numbers from column named "phone_no" or similar
//             const phones = data
//                 .map((row) => row.phone_no?.toString().trim())
//                 .filter((val, i, arr) => val && arr.indexOf(val) === i); // remove duplicates

//             setPhoneNumbers(phones);
//         };

//         reader.readAsBinaryString(file);
//     };

//     const handleExtendMembership = async () => {
//         const now = new Date();
//         const oneMonthLater = new Date();
//         oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);

//         try {
//             const snapshot = await getDocs(collection(db, "nv_glow_membership"));
//             const updates = [];

//             snapshot.docs.forEach((docSnap) => {
//                 const data = docSnap.data();
//                 const endDate = data.end_date?.toDate?.() || new Date(data.end_date);

//                 if (
//                     phoneNumbers.includes(data.phone_no?.toString()) &&
//                     endDate < now
//                 ) {
//                     updates.push(
//                         updateDoc(doc(db, "nv_glow_membership", docSnap.id), {
//                             end_date: Timestamp.fromDate(oneMonthLater),
//                         })
//                     );
//                 }
//             });

//             await Promise.all(updates);
//             alert("✅ Memberships extended by 1 month.");
//         } catch (error) {
//             console.error("❌ Error updating memberships:", error);
//         }
//     };

//     return (
//         <div className="container mt-5">
//             <div className="card shadow p-4">
//                 <h2 className="text-center mb-4">Extend Expired Memberships</h2>

//                 <div className="mb-3">
//                     <label className="form-label">Upload Excel File (.xlsx or .xls)</label>
//                     <input
//                         type="file"
//                         accept=".xlsx,.xls"
//                         className="form-control"
//                         onChange={handleFileUpload}
//                     />
//                 </div>

//                 {phoneNumbers.length > 0 && (
//                     <div className="table-responsive mb-3">
//                         <table className="table table-bordered">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th>#</th>
//                                     <th>Phone Number</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {phoneNumbers.map((phone, index) => (
//                                     <tr key={index}>
//                                         <td>{index + 1}</td>
//                                         <td>{phone}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}

//                 <button
//                     className="btn btn-success w-100"
//                     onClick={handleExtendMembership}
//                     disabled={phoneNumbers.length === 0}
//                 >
//                     Submit & Extend Membership
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default ExtendMembership;


















import React, { useState } from "react";
import { collection, query, where, getDocs, updateDoc, doc, Timestamp, addDoc } from "firebase/firestore";
import db from "./Firebase";
import * as XLSX from "xlsx";
import { Table, Button } from "react-bootstrap";

const ExtendMembership = () => {
    const [phoneNumbers, setPhoneNumbers] = useState([]);
    const [loading, setLoading] = useState(false);

    // Parse Excel/CSV file
    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

            const phones = data.map(row => row[0]).filter(p => typeof p === "string" || typeof p === "number");
            setPhoneNumbers(phones);
        };

        reader.readAsBinaryString(file);
    };

    const submitMembershipLog = async (phoneNo, startDate, endDate) => {
        const createdDate = new Date();

        try {
            await addDoc(collection(db, "extended_membership_log"), {
                phone_no: phoneNo,
                start_date: Timestamp.fromDate(startDate),
                end_date: Timestamp.fromDate(endDate),
                created_date: Timestamp.fromDate(createdDate),
            });
            console.log("✅ Log added successfully for", phoneNo);
        } catch (error) {
            console.error("❌ Error adding log:", error);
        }
    };


    const extendMemberships = async () => {
        setLoading(true);
        const now = new Date();
        const nextMonth = new Date(now.setMonth(now.getMonth() + 1));

        const updates = [];

        for (const phone of phoneNumbers) {
            const q = query(collection(db, "nv_glow_membership"), where("phone_no", "==", String(phone)));
            const snapshot = await getDocs(q);

            snapshot.forEach((docSnap) => {
                updates.push(
                    updateDoc(doc(db, "nv_glow_membership", docSnap.id), {
                        end_date: Timestamp.fromDate(nextMonth),
                        start_date: Timestamp.now(),
                    })
                );
            });
            submitMembershipLog(phone, now, nextMonth); // Log the membership extension
        }

        try {
            await Promise.all(updates);
            alert("✅ Memberships extended by 1 month from today.");
        } catch (error) {
            console.error("❌ Error updating memberships:", error);
            alert("❌ Error updating memberships.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <label className="form-label">Upload Excel File (.xlsx or .xls)</label>

            <div className="mb-3 mt-3">
                <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" className="form-control" onChange={handleFileUpload} />
            </div>

            {phoneNumbers.length > 0 && (
                <>
                    <h5 className="mt-4">Phone Numbers</h5>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Phone Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            {phoneNumbers.map((phone, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{phone}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <Button variant="primary" onClick={extendMemberships} disabled={loading}>
                        {loading ? "Updating..." : "Submit and Extend 1 Month"}
                    </Button>
                </>
            )}
        </div>
    );
};

export default ExtendMembership;